import React, { useState, useEffect, useRef } from 'react';
import './RunningNumbers.scss';

const RunningNumbers = () => {
    const [counts, setCounts] = useState({
        experience: 0,
        codeLines: 0,
        uke: 0,
        drinks: 0
    });

    const targetCounts = {
        experience: 6,
        codeLines: 326547,
        uke: 854,
        drinks: 112
    };

    const containerRef = useRef(null);
    const animationRef = useRef(null);

    const startCounting = () => {
        const duration = 2000; // 2 seconds
        const steps = 60; // 60 steps for smooth animation
        const stepDuration = duration / steps;

        let currentStep = 0;
        const stepValues = {};

        // Calculate step values for each count
        Object.keys(targetCounts).forEach(key => {
            stepValues[key] = targetCounts[key] / steps;
        });

        const animate = () => {
            if (currentStep >= steps) {
                // Ensure we reach exact target values
                setCounts(targetCounts);
                return;
            }

            setCounts(prevCounts => {
                const newCounts = { ...prevCounts };
                Object.keys(targetCounts).forEach(key => {
                    // Use Math.ceil for small numbers to ensure they start counting up immediately
                    const currentValue = key === 'drinks' 
                        ? Math.floor(prevCounts[key] + stepValues[key])
                        : Math.ceil(prevCounts[key] + stepValues[key]);
                    
                    newCounts[key] = Math.min(currentValue, targetCounts[key]);
                });
                return newCounts;
            });

            currentStep++;
            animationRef.current = setTimeout(animate, stepDuration);
        };

        animate();
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setTimeout(() => {
                        startCounting();
                    }, 1000);
                    observer.disconnect();
                }
            },
            { threshold: 0.5 }
        );

        if (containerRef.current) {
            observer.observe(containerRef.current);
        }

        return () => {
            if (animationRef.current) {
                clearTimeout(animationRef.current);
            }
            observer.disconnect();
        };
    }, []);

    return (
        <div id="numbers" className="running-numbers" ref={containerRef}data-aos="fade-up" 
        data-aos-duration="1500">
            <div className="numbers-container">
                <div className="number-item">
                    <div className="icon experience"></div>
                    <span className="number">{counts.experience}</span>
                    <span className="label">Years of Experience</span>
                </div>
                <div className="number-item">
                    <div className="icon code-lines"></div>
                    <span className="number">{counts.codeLines}</span>
                    <span className="label">Lines of code written (approximately...)</span>
                </div>
                <div className="number-item">
                    <div className="icon uke"></div>
                    <span className="number">{counts.uke}</span>
                    <span className="label">Hours <a href="https://www.youtube.com/watch?v=sO-j7nc2Ma4&ab_channel=Jewkulele" target='_blank' rel='noopener noreferrer'>playing the ukulele</a> while waiting for things to load</span>
                </div>
                <div className="number-item">
                    <div className="icon drinks"></div>
                    <span className="number">{counts.drinks}</span>
                    <span className="label">Bottles of Faxe Kondi <br></br> (I'm new to Denmark)</span>
                </div>
            </div>
        </div>
    );
};

export default RunningNumbers; 